export const strings = {
  rejected: {
    title: 'Ret Notu',
    subtitle: 'Vaka sahibine bir not göndererek bu durumu reddedin.',
    action: 'Reddetmek',
    button_title: 'Red',
    status_slug: 'Reddedildi',
  },
  approved: {
    title: 'Onay Notu',
    subtitle: 'Bu davayı, dava sahibine bir not ekleyerek onaylayın.',
    action: 'Onaylamak',
    button_title: 'Onaylamak',
    // status_slug: 'onaylı',
    status_slug: 'approved',
  },
  archive: {
    title: 'Arşiv Notu : ',
    subtitle: 'Bu vakayı, vaka sahibine bir not ekleyerek arşivleyin.',
    action: 'Arşiv',
    button_title: 'Arşiv',
    // status_slug: 'arşiv',
    status_slug: 'archive',
  },
  unarchive: {
    title: 'Arşivden Çıkarma Notu',
    subtitle: 'Bu vakayı, vaka sahibine bir not ekleyerek arşivden çıkarın.',
    action: 'Arşivden çıkar',
    button_title: 'Arşivden çıkar',
    // status_slug: 'kapalı',
    status_slug: 'close',
  },
  close: {
    title: 'Kapanış Notu :',
    subtitle: 'Bu davayı, dava sahibine bir not yazarak kapatın.',
    action: 'Kapalı',
    button_title: 'Kapalı',
    // status_slug: 'kapalı',
    status_slug: 'close',
  },
  reopen: {
    title: 'Yeniden Aç Notu',
    subtitle: 'Bu davayı, dava sahibine bir not ekleyerek yeniden açın.',
    action: 'Yeniden aç',
    button_title: 'Yeniden Aç',
    // status_slug: 'açık',
    status_slug: 'open',
  },
  action_cannot_undone: 'Bu işlem geri alınamaz',
  cancel: 'İptal',
  note_placeholder: 'Buraya yazın..',
  note_helper: 'Maksimum 1000 karakter',
  add_Case_button: 'Vaka/Soru Ekle',
};
